export class LoginResult {
  public status: number;
  public userCreateStatus: number;
  public success: boolean;
  public contractList: any;
}

export interface TimedOutData {
  reLogin: boolean;
  currentRoute: string;
  username: string;
}
